<template>
    <v-container fluid grid-list-md>
      <v-row no-gutters class="pa-0">
        <v-col cols="12" xl="6" lg="6" xs="6" sm="6" md="6">
          <h1>{{this.$store.state.documentActivLoc}}</h1>
        </v-col>
        <v-col cols="12" xl="6" lg="6" xs="6" sm="6" md="6">
          <div class="text-right">
              <v-btn fab dark class="indigo" @click="newitem">
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
          </div>
        </v-col>
      </v-row>
      <app-Item-list></app-Item-list>
    </v-container>
</template>

<script>

import Itemlist from './ItemList'

export default {
  name: 'item',
  data () {
    return {
      msg: ''
    }
  },
  mounted () {

  },
  methods: {
    async newitem () {
      try {
        await this.$router.push({
          name: 'itemcreate'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    }
  },
  computed: {

  },
  watch: {

  },
  components: {
    appItemList: Itemlist
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
